import configService from './config'
const axios = require('axios')

const clientAuth = axios.create({
  baseURL: configService.apiAuth
})

const client = axios.create({
  baseURL: configService.apiUrl
})

export { clientAuth }
export default client


